var _rect, _line, _path, _line2, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterHeaterShutOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.05,
    height: 16,
    viewBox: "0 0 16.05 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Water Heater Shut Off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.02,
    width: 16,
    height: 16,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 8,
    x2: 5,
    y2: 8,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,8",
    transform: "translate(0.02)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.05,
    y1: 8,
    x2: 11.05,
    y2: 8,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5.03 6.5 5.03 9.5 8.03 8 5.03 6.5",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.05 6.5 11.05 9.5 8.05 8 11.05 6.5",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHeaterShutOff);
export default __webpack_public_path__ + "static/media/WaterHeaterShutOff.649e28324ea6a128f9150e763e28b97d.svg";
export { ForwardRef as ReactComponent };